<template>
	<div>
		<Header :sel="1" @changePhone="changePhone"></Header>
		<!--{* carousel *}-->
		<!--{* banner *}-->
		<div class="x-banner">
			<el-carousel class="el-carousel" :interval="5000" height="40vw" indicator-position="none"
				@change="handleSlideChange">
				<el-carousel-item v-for="item in bannerList" :key="item.id">
					<div class="slide-content">
						<img :src="item.url" class="slide-image" @click="goHref(item.href)" />
					</div>
				</el-carousel-item>
			</el-carousel>

			
		</div>



		<!--{* 关于我们 *}-->
		<section class="i-about">
			<div class="l">
				<div class="con">
					<div class="i-title wow fadeIn">
						<div class="zh" style="color: #494949;">ABOUT US</div>
						<div class="en" style="color: #494949;">
							关于恒润
						</div>
					</div>
					<div class="text wow fadeIn" >
						<!-- <div class="edit-box" v-html="aboutData.cmsArticleData?aboutData.cmsArticleData.content:''">

						</div> -->
						<div class="edit-box">
						<p>{{aboutData.describtion}}</p></div>
					</div>
					<a href="javascript:void(0)"
						@click="go('companyInfo?type='+aboutData.categoryCode+'&id='+aboutData.id)" class="i-more">
						查看更多 >>
					</a>
				</div>


			</div>
			<div class="r wow">
				<div class="full imgbg" :style="{ 'background-image': 'url(' + aboutData.image + ')' }"></div>
			</div>
		</section>









		<div class="c2" style="width: 100%;">
			<ul class="list2"style="width: 100%;">
				<li>
					<div class="img">
						<img src="@/assets/images/yewu.png" width="100%">
					</div>
				</li>
				<li>
					<div class="img">
						<img src="@/assets/images/yewu.png" width="100%">
					</div>
				</li>
				<li>
					<div class="img">
						<img src="@/assets/images/yewu.png" width="100%">
					</div>
				</li>
				<li>
					<div class="img">
						<img src="@/assets/images/yewu.png" width="100%">
					</div>
				</li>
				<li>
					<div class="img">
						<img src="@/assets/images/yewu.png" width="100%">
					</div>
				</li>
			</ul>
			<div class="con">
				<div class="wh con1">
					<div class="c2-1 wow fadeIn">
						<h2>
							Business domain
						</h2>
						<h3>
							业务领域
						</h3>
						<a href="javascript:void(0)" @click="go('businessList')" class="i-more2">查看更多>></a>

					</div>
					<ul class="list3 wow slideInRight">
						<li @click="goBus('200008')">
							<div class="img">
								<img src="@/assets/images/lingyu1.png">
							</div>
							<h2>
								水利市政
								<span>Trade field</span>
							</h2>
							<dd>

							</dd>
							<div class="ck">
								<img src="@/assets/images/2e83cc1e5fc3653b384d0d9e258defcf269042e0.png" alt="">
							</div>
						</li>
						<li @click="goBus('200009')">
							<div class="img">
								<img src="@/assets/images/lingyu2.png">
							</div>
							<h2>
								雷达天线
								<span>New energy field</span>
							</h2>
							<dd>

							</dd>
							<div class="ck">
								<img src="@/assets/images/2e83cc1e5fc3653b384d0d9e258defcf269042e0.png" alt="">
							</div>
						</li>
						<li @click="goBus('200010')">
							<div class="img">
								<img src="@/assets/images/lingyu3.png">
							</div>
							<h2>
								新能源
								<span>Rural health care</span>
							</h2>
							<dd>

							</dd>
							<div class="ck">
								<img src="@/assets/images/2e83cc1e5fc3653b384d0d9e258defcf269042e0.png" alt="">
							</div>
						</li>
						<li @click="goBus('200011')">
							<div class="img">
								<img src="@/assets/images/lingyu4.png">
							</div>
							<h2>
								共享智造
								<span>Rural health care</span>
							</h2>
							<dd>

							</dd>
							<div class="ck">
								<img src="@/assets/images/2e83cc1e5fc3653b384d0d9e258defcf269042e0.png" alt="">
							</div>
						</li>

					</ul>
				</div>
			</div>
		</div>

		<!--{* 项目风采 *}-->
		<section class="i-style">
			<div class="i-title wow fadeIn">
				<div class="zh" style="color: #feffff;">Project Case</div>
				<div class="en">
					项目案例
				</div>
			</div>
			<div class="swiper fade-swiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide stop item" v-for="(item,index) in caseList">
						<ul class="swiper-wrapper">
							<li class="swiper-slide imgbox">
								<img :src="item.image" v-if="item.image">
								<!-- <img src="@/assets/images/case1.png" v-else> -->
							</li>
						</ul>
						<div class="fraction"><span class="swiper-pagination-current">{{index+1}}</span> /
							<span class="swiper-pagination-total">{{caseList.length}}</span>
						</div>
					</div>

				</div>
			</div>
			<div class="fade-swiper-nav wh wow fadeIn"  style="width: 100%; overflow: hidden;">
				<div class="swiper-btn circle iconfontx iconx-arrL prev"></div>
				<div class="swiper flex-1">
					<ul class="swiper-wrapper">
						<li class="swiper-slide" v-for="(item,index) in caseList">
							<div class="dot circle"></div>
							<p>{{item.title}}</p>
						</li>
					</ul>
				</div>
				<div class="swiper-btn circle iconfontx iconx-arrR next"></div>
			</div>
		</section>




		<div class="c3">
			<div class="wh">
				<h2 class="wow slideInUp">
					group dynamics
				</h2>
				<div class="tit wow slideInUp">
					<h3>
						集团动态
					</h3>
					<a href="javascript:void(0)" @click="go('newList')" class="i-more">
						查看更多 >>
					</a>
				</div>
				<div class="con wow slideInUp">

					<div class="c3-2">
						<ul class="list2">
							<li v-for="item in dtList">
								<a href="javascript:void(0)" @click="goDetail(item.id, item.categoryName)">

									<h4>
										{{item.title}}
									</h4>
									<div><img :src="item.image"></div>
									<dd>
										{{item.describtion}}
									</dd>
									<div class="sc">

										more>>
									</div>
								</a>
							</li>



						</ul>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="" width="80%" :visible.sync="outerVisible">
			<div class="tanchuang_c">
				<div class="yewu_t">{{szData.title}}</div>
				<div class="yewu_c">
					<div v-html="szData.cmsArticleData?szData.cmsArticleData.content:''"></div>
				</div>
				<a href="javascript:void(0)" @click="go('newList')" class="i-more">
					查看更多 >>
				</a>
				<ul class="xypg-product-list clearfix">
					<li v-for="item in szList" @click="goBusDetail(item.id)">
						<a href="javascript:void(0)" class="img"><img :src="item.image" /></a>
						<h3><a href="javascript:void(0)">{{item.title}}</a></h3>
					</li>
				</ul>
			</div>
		</el-dialog>
		<Footer></Footer>
	</div>

	</div>
</template>





<script>
	import {
		WOW
	} from 'wowjs'
	import {
		imgDraggable,
		hoverOn,
		setSwiper
	} from '@/assets/js/tools.min1.js'
	import Header from '@/components/header.vue';
	import Footer from '@/components/footer.vue';
	import $ from 'jquery';
	import '@/assets/js/jquery.superslide.js'
	import '@/assets/js/jquery.validator.js'
	import '@/assets/js/jquery.SuperSlide.2.1.3.js'
	import {
		categorysortPage,
		articleList,
		bannerList,
		articleDetail
	} from '@/api/reqFetch.js';
	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				screenheight: '',

				selId: '1',
				list: [],
				newList: [],
				newList1: [],
				jicenglist: [],
				tabList: [],
				selName: '全部',
				selid: '0',
				talentList: [],
				companyList: [],
				tableData: [],
				indexData: 0,
				pageNum: 4,
				bannerList: [],
				infoList1: [],
				infoList2: [],
				infoList3: [],
				index: 0,
				companyData: {},
				showPhone: false,
				adData: {},
				adData2: {},
				centerrightList: [],
				bottomList: [],
				activeIndex: 0,
				topBanner: '',
				centerBanner: '',
				detailLoading: false,
				subNewsListMap: {},
				aboutData: {}, //关于恒润
				dtList: [], //集团动态
				caseList: [], //项目案例
				ywList: [],
				outerVisible: false,
				szList: [], //业务弹窗产品
				szData: {}, //业务弹窗详情
			};
		},

		mounted() {
			this.checkImg();
			this.getCategorysortPage();
			this.getBannerList();
		},

		methods: {
			checkImg() {
				$(window).width() > 980 && ((new WOW).init(),
						$(".wow").attr("data-wow-duration", "1.5s")),
					imgDraggable();
				var wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true
				});
				wow.init();
				const w = window.screen.width
				if (w > 980) {
					hoverOn('.i-service .options .btnx', '.i-service .item');
				} else {
					const btn = $('.i-service .options .btnx');
					const item = $('.i-service .item');
					const cons = item.find('.con');
					item.eq(0).addClass('on');

					btn.click(function() {
						const el = $(this);
						const index = el.index();
						const con = item.eq(index).find('.con');
						el.addClass('on').siblings().removeClass('on');
						item.eq(index).addClass('on').siblings().removeClass('on');
						if (con.hasClass('on')) {
							con.removeClass('on')
						} else {
							cons.removeClass('on');
							con.addClass('on');
						}
					})
				}

				const fadeSwiper = setSwiper('.fade-swiper', {
					autoplay: false,
					// effect: 'fade'
				})

				setSwiper('.i-style .item', {
					delay: 5000,
					effect: 'fade',
					// paginationEl: '.i-style .item .fraction',
					// paginationType: 'fraction'
				})

				if (w > 980) {

					setSwiper('.fade-swiper-nav .swiper', {
						autoplay: false,
						slidesPerView: 5,
						centeredSlides: true,
						prevEl: '.fade-swiper-nav .prev',
						nextEl: '.fade-swiper-nav .next',
						on: {
							slideChangeTransitionStart() {
								const index = this.realIndex;
								fadeSwiper.slideTo(index);
							}
						}
					})
				} else {

					setSwiper('.fade-swiper-nav .swiper', {
						autoplay: false,
						slidesPerView: "auto",
						centeredSlides: true,
						prevEl: '.fade-swiper-nav .prev',
						nextEl: '.fade-swiper-nav .next',
						on: {
							slideChangeTransitionStart() {
								const index = this.realIndex;
								fadeSwiper.slideTo(index);
							}
						}
					})

				}
				setTimeout(() => {
					this.$nextTick(() => {
						jQuery(".c2").slide({
							titCell: ".list3 li",
							mainCell: ".list2"
						});
					});
				})
			},
			goBusDetail(id){
				this.$router.push({
					path: '/productDetail?id='+id,
				})
			},
			goBus(type, name) {
				this.szData = {}
				this.szList = []
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: type,
					isComment: 0
				}).then(res => {
					if (res.rows.length > 0) {
						this.getSzDetail(res.rows[0].id)
					}

				});
				articleList({
					pageNum: 1,
					pageSize: 8,
					status: 1,
					categoryCode: type,
					isComment: 1
				}).then(res => {
					this.szList = res.rows
				});
				this.outerVisible = true
			},
			getSzDetail(id) {
				articleDetail({
					id: id
				}).then(res => {
					this.szData = res.data;
					try {
						let cmsArticleData = this.szData.cmsArticleData
						if (cmsArticleData && cmsArticleData.content) {
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g,
								'<div class="su-space"></div>')
						}
						this.szData = {
							...this.szData,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}

				});
			},
			goDetail(id, name) {
				const route = this.$router.resolve({
					path: '/context',
					query: {
						id: id,
						name: name
					},
				});
				window.open(route.href, '_blank');
			},
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			},

			handleSlideChange(index) {
				this.activeIndex = index;
			},
			getCategorysortPage() {
				categorysortPage({
					pos: 'middle',
				}).then(res => {
					this.centerrightList = res.data;
					res.data.map(item => {
						if (item.categoryName == '公司介绍') {
							this.getAbout(item.categoryCode);
						} else if (item.categoryName == '集团动态') {
							this.getDtList(item.categoryCode);
						} else if (item.categoryName == '项目案例') {
							this.getCaseList(item.categoryCode);
						} else if (item.categoryName == '业务范围') {
							this.ywList = item.children
						}
					})


				});
			},
			getAbout(categoryCode) {
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: categoryCode,
				}).then(res => {
					this.getAboutDetail(res.rows[0].id)
				});
			},
			getAboutDetail(id) {
				articleDetail({
					id: id
				}).then(res => {
					this.aboutData = res.data;
					try {
						let cmsArticleData = this.aboutData.cmsArticleData
						if (cmsArticleData && cmsArticleData.content) {
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g,
								'<div class="su-space"></div>')
						}
						this.aboutData = {
							...this.aboutData,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}

				});
			},
			getDtList(categoryCode) {
				articleList({
					pageNum: 1,
					pageSize: 4,
					status: 1,
					categoryCode: categoryCode,
				}).then(res => {
					this.dtList = res.rows;
				});
			},
			getCaseList(categoryCode) {
				articleList({
					pageNum: 1,
					pageSize: 8,
					status: 1,
					categoryCode: categoryCode,
				}).then(res => {
					this.caseList = res.rows;
					this.checkImg()
				});
			},

			getCategorysortPage1() {
				categorysortPage({
					pos: 'bottom',
				}).then(res => {
					this.bottomList = res.data;
					this.detailLoading = true;
					setTimeout(() => {
						this.getNewList1(0, res.data[0].categoryCode);
						this.getNewList1(1, res.data[1].categoryCode);
						this.getNewList1(2, res.data[2].categoryCode);
					}, 500);
				});
			},

			changePhone(val) {
				this.showPhone = val;
			},
			imgLoad() {
				this.$nextTick(() => {
					this.screenheight = this.$refs.bannerHeight[0].height + 'px';
				});
			},
			goProDetail(id) {
				const route = this.$router.resolve({
					path: '/productDetail',
					query: {
						id: id,
					},
				});
			},
			goMore(url) {
				const route = this.$router.resolve(url);
			},
			goDetail(id, categoryName) {
				// 将 categoryName 转换为字符串类型
				categoryName = String(categoryName);
				if (categoryName === '保险史话' || categoryName === '学会纪实') {
					const route = this.$router.resolve({
						path: '/productDetail',
						query: {
							id: id,
						},
					});
					window.open(route.href, '_blank');
				} else {
					const route = this.$router.resolve({
						path: '/context',
						query: {
							id: id,
						},
					});
					window.open(route.href, '_blank');
				}
			},
			// goProDetail(id) {
			// 	const route = this.$router.resolve({
			// 		path: '/productDetail',
			// 		query: {
			// 			id: id
			// 		}
			// 	});
			// 	window.open(route.href, '_blank');
			// },
			goHref(url) {
				window.open(url);
			},

			getBannerList() {
				bannerList({}).then(res => {
					this.bannerList = res.rows;
				});
			},
			changeTab(id, name) {
				this.selName = name;
				this.selid = id;
				this.init();
			},

			getBanners() {
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: '1000001',
				}).then(res => {
					if (res.rows.length > 0) {
						this.centerBanner = res.rows[0].image;
					}
				});
			},

			getNewList1(type, categoryCode) {
				articleList({
					pageNum: 1,
					pageSize: 6,
					status: 1,
					categoryCode: categoryCode,
				}).then(res => {
					this.detailLoading = false
					console.log(type, categoryCode)
					this.bottomList[type].newList = res.rows;
					this.subNewsListMap = {
						...this.subNewsListMap,
						[categoryCode]: res.rows
					}
				});
			},
			getMemberPageList() {
				//类型 1 产险 2 寿险
				memberPageList({
					pageNum: 1,
					pageSize: 99,
					memberType: '1',
				}).then(res => {
					this.infoList1 = res.rows;
				});
				memberPageList({
					pageNum: 1,
					pageSize: 99,
					memberType: '2',
				}).then(res => {
					this.infoList2 = res.rows;
				});
			},
			getWebsiteList() {
				websiteList({
					pageNum: 1,
					pageSize: 20,
				}).then(res => {
					this.companyList = res.rows;
				});
			},
			pros_hover(id) {
				this.selId = id;
				this.getNewList();
			},
			goMore(url) {
				this.$router.push(url);
			},
			// goDetail(id) {
			// 	this.$router.push({
			// 		path: '/context',
			// 		query: {
			// 			id: id
			// 		}
			// 	})
			// },
			goqyDetail(id) {
				const route = this.$router.resolve({
					path: '/context',
					query: {
						id: id,
					},
				});
				window.open(route.href, '_blank');
			},
		},
	};
</script>

<style scoped>
	.el-carousel {
		width: 100%;
	}

	.tanchuang_c {
		width: 97%;
		margin: 0 auto;
	}

	.yewu_t {
		color: #0074b1;
		font-size: 30px;
		font-weight: bold;
	}

	.yewu_c {
		font-size: 16px;
		line-height: 30px;
		height: 210px;
		overflow-y: hidden;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.xypg-product-list {
		padding-top: 20px;
	}

	.logo-img {
		width: 180px;
		height: 55px;
		flex-shrink: 0;
	}

	.slider-wrapper {
		overflow: hidden;
	}

	.slider {
		display: flex;
		width: 600%;
		/* 设置合适的宽度 */
		animation: scroll 260s linear infinite;
		/* 调整时间以匹配图片数量和滚动速度 */
	}

	@keyframes scroll {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-100%);
		}

		/* 图片宽度总和的负值 */
	}

	.custom-carousel {
		position: relative;
		width: 100%;
		overflow: hidden;
	}

	.slide-content {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.slide-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		cursor: pointer;
	}

	/* 	.caption {
		position: absolute;
		height: 60px; line-height:60px; overflow: hidden;
		color: #fff;
		text-align: left;
		width: 100%;
		background: linear-gradient(to right, rgba(0, 0, 0, 0.8), transparent);
		display: flex;
		z-index: 9;
		bottom: 0;
		padding: 20px;
		
		justify-content: space-between;
		align-items: center;
	} */

	/* 自定义指示器样式 */
	.custom-indicators {
		z-index: 2;
		display: flex;
	}

	.indicator-item {
		width: 8px;
		height: 8px;
		margin: 0 8px;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, 0.5);
		cursor: pointer;
		transition: all 0.3s;
	}

	.indicator-item.is-active {
		background-color: #fff;
	}

	/* 覆盖element-ui默认样式 */
	/deep/ .el-carousel__arrow {
		background-color: rgba(0, 0, 0, 0.3) !important;
	}

	/deep/ .el-carousel__arrow:hover {
		background-color: rgba(0, 0, 0, 0.6) !important;
	}

	.main_c_placeholder {
		display: flex;
		flex-direction: column;
		gap: 10px;

		li {
			width: 100%;
			height: 30px;
			background-color: #f0f0f0;
		}
	}

	.swiper-title-home {
		/* 显示1行，多余... */
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
</style>